module.exports = __webpack_public_path__ + "static/planeta_loving-701362d3e06594ae5a2d23a5bd786a75.webp";